import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        bonuses: {
          add_bonus: {
            header: 'HEADER',
            add_bonus: 'PLAYERS_BONUSES_ADD_BONUS',
            back: 'BACK',
            tabs: {
              manual: {
                tab_name: 'TAB_NAME_MANUALLY',
              },
              from_file: {
                tab_name: 'TAB_NAME_FILE',
              },
            },
          },
        },
      },
    },
  }));
}
